module.exports = __webpack_public_path__ + "img/47.5652c8bd.png";